class TabsComponent extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('.tab-button');
    this.panels = this.querySelectorAll('.tab-panel');
    this.navWrapper = this.querySelector('.tabs-nav-wrapper');
    
    this.buttons.forEach(button => {
      button.addEventListener('click', this.handleTabClick.bind(this));
    });
  }

  handleTabClick(event) {
    const clickedButton = event.currentTarget;
    const targetIndex = clickedButton.dataset.index;

    this.buttons.forEach(button => {
      button.classList.remove('active');
      button.setAttribute('aria-selected', 'false');
    });
    clickedButton.classList.add('active');
    clickedButton.setAttribute('aria-selected', 'true');

    this.panels.forEach(panel => {
      if (panel.dataset.index === targetIndex) {
        panel.classList.add('active');
        panel.removeAttribute('hidden');
      } else {
        panel.classList.remove('active');
        panel.setAttribute('hidden', '');
      }
    });

    clickedButton.scrollIntoView({ 
      behavior: 'smooth', 
      block: 'nearest', 
      inline: 'center' 
    });
  }
}

customElements.define('tabs-component', TabsComponent);